import { createContentStats } from "../content-stats/content-stats";
import "./content-section.css";

export const createContentSection = () => {
  createContentStats();
};
